import { ISymbolGroupsStoreSegment } from './symbolGroups.interface';

export const symbolGroupsStoreSelector = (state: ISymbolGroupsStoreSegment) => state.symbolGroups;
